// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1hYSz","label":"Category_label__2Joij","content":"Category_content__3d6So","header":"Category_header__14Vi3","location":"Category_location__9FsDq"};